
import { createBrowserRouter, Outlet } from "react-router-dom";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Practice from "./pages/Practice";
import AllDrafts from "./pages/AllDrafts";
import NotFound from "./pages/NotFound";
import SharedEssay from "./pages/SharedEssay";
import AuthCallback from "./pages/AuthCallback";
import ResetPassword from "./pages/ResetPassword";
import { AuthProvider } from "./contexts/AuthContext";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundsPolicy from "./pages/RefundsPolicy";
import TutorialPage from "./pages/TutorialPage";
import { Tutorial } from "./components/tutorial/Tutorial";

const AppLayout = () => {
  return (
    <AuthProvider>
      <Tutorial>
        <Outlet />
      </Tutorial>
    </AuthProvider>
  );
};

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: <Index />,
      },
      {
        path: "/auth",
        element: <Auth />,
      },
      {
        path: "/auth/callback",
        element: <AuthCallback />,
      },
      {
        path: "/auth/reset-password",
        element: <ResetPassword />,
      },
      {
        path: "/dashboard",
        element: <Dashboard />,
      },
      {
        path: "/practice",
        element: <Practice />,
      },
      {
        path: "/all-drafts",
        element: <AllDrafts />,
      },
      {
        path: "/shared/:draftId",
        element: <SharedEssay />,
      },
      {
        path: "/terms-and-conditions",
        element: <TermsAndConditions />,
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "/refunds-policy",
        element: <RefundsPolicy />,
      },
      {
        path: "/tutorial",
        element: <TutorialPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);
